import React, { PureComponent } from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import styled, { css } from "styled-components";
import { Color } from "Styles/Theme";

const newStyles = {
  variables: {
    light: {
      diffViewerBackground: "white",
      diffViewerColor: "black",
      addedBackground: "white",
      addedColor: "#black",
      removedBackground: "white",
      removedColor: "grey",
      wordRemovedBackground: "white",
    },
  },
  diffContainer: {
    border: "1px solid black",
    marginTop: "30px",
    heigth: "300px",
  },

  titleBlock: {
    backgroundColor: Color.purple,
    width: "100px",
    fontSize: "15px",
    textAlign: "center",
    color: "red",
  },
};

const DiffResult = ({ id, originText, revisionArr }) => {
  class Diff extends PureComponent {
    render = () => {
      return (
        <ReactDiffViewer
          oldValue={originText}
          newValue={revisionArr[id].correction}
          splitView={true}
          compareMethod={DiffMethod.WORDS_WITH_SPACE}
          showDiffOnly={false}
          styles={newStyles}
          hideLineNumbers={true}
          leftTitle={"원본"}
          rightTitle={"수정본"}
        />
      );
    };
  }
  return (
    <Container>
      <QuestionSection>
        <div>Q{id + 1}.</div>
        <div>{revisionArr[id].question}</div>
      </QuestionSection>
      <QuestionLine />
      <ContentsSection>
        <Diff />
      </ContentsSection>
      <CommentSection>
        <div className="commentTitleWrap">
          <TextTitleTap>코멘트</TextTitleTap>
          <div className="commentBar" />
        </div>
        <div className="commentTextBox">
          <textarea value={revisionArr[id].comment}></textarea>
        </div>
      </CommentSection>
    </Container>
  );
};

export default DiffResult;

const FlexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Themecolor = css`
  color: #7903d4;
`;

const Container = styled.section`
  width: 1200px;
  margin: 0px auto;
  table {
    span {
      display: inline;
    }
    width: 1140px;
    tbody {
      & tr:nth-child(1) {
        & td {
          & pre {
            color: white;
            font-weight: bold;
          }
        }
      }
      & tr:nth-child(2) {
        & td:nth-child(1) {
          pre {
            display: none;
          }
        }
        & td:nth-child(3) {
          pre {
            display: none;
          }
        }
        & td:nth-child(2n) {
          padding: 30px;
          height: 500px;
          border-right: 1px solid black;
        }
      }
    }
  }
`;
const QuestionSection = styled.div`
  ${FlexCenter}
  justify-content: start;
  padding: 0px 30px;
  margin-top: 100px;

  & > div:nth-child(1) {
    ${Themecolor}
    font-size: 50px;
    font-weight: bold;
    font-style: italic;
    text-align: center;
  }
  & > div:nth-child(2) {
    margin-left: 13px;
    font-size: 17px;
    line-height: 1.5;
    color: #676767;
  }
`;
const QuestionLine = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 30px;
  background-color: #b3b3b3;
`;
const ContentsSection = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 70px;
  margin-bottom: 70px;
`;

const CommentSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  .commentTitleWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    .commentBar {
      width: 1068px;
      height: 2px;
      margin-bottom: 20px;
      background-color: #7903d4;
    }
  }
  .commentTextBox {
    display: flex;
    justify-content: center;

    textarea {
      width: 1139px;
      height: 129px;
      padding: 31px 23px 46px 19px;
      border: solid 1px #b3b3b3;
      resize: none;
    }
  }
`;

const TextTitleTap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 25px;
  margin-bottom: 20px;
  background-color: #7903d4;
  color: white;
`;
